<script>
  import Brand from './brand'
  import MenuUser from './menuUser'
  import MenuApp from './menuApp'
  import {mapGetters} from 'vuex';

  import headerUtils from './HeaderUtils';

  import subMenu from './subMenu';

  export default {
    name: 'pa-header',
    components: {Brand, MenuApp, MenuUser, subMenu},
    computed: {
      ...mapGetters([
        'isLogged',
        'loggedUser'
      ]),
      showBusinessLine: function () {
        if (this.$route.params.businessAreaId) {
          return (this.loggedUser.businessLines.length > 1);
        }
      },
      showContracts: function () {
        if (this.$route.params.systemId) {
          return (_.find(this.loggedUser.businessLines, {'id': this.$route.params.businessAreaId}).contracts.length > 1);
        }
      },
      contractMenuShow: function () {
        return this.$route.params.systemId
      }
    }
  }
</script>

<template>
  <header>
    <div class="top-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xs-12">

            <div class="row">
              <div class="col-xs-2 b2">
                SGS Now
              </div>

              <div class="col-xs-6 font-size-12px">
                <ul class="menu-1">
                  <li class="padding-right-10px">
                    <a href="http://www.sgsgroup.com.br">{{ $t('sgsHome') }}</a>
                  </li>
                  <li class="border-left-1px padding-left-10px">
                    <a href="http://www.sgs.com">{{ $t('sgsAroundTheWorld') }}</a>
                  </li>
                  <li class="border-left-1px padding-left-10px">
                    <a href="http://www.sgs.com/en/office-directory">{{ $t('contactUs') }}</a>
                  </li>
                </ul>
              </div>

              <div class="col-xs-4 font-size-12px">
                <MenuUser/>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <nav class="navbar border-sgs">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-2">
            <Brand/>
          </div>
          <div class="col-sm-10" v-if="isLogged">

            <ul class="menu root">
              <router-link :to="{ name: 'BusinessAreaList'}" tag="li" exact v-show="showBusinessLine">
                <a>{{$t("businessLine")}}</a>
              </router-link>
              <router-link :to="{ name: 'SystemsList'}" tag="li" exact v-show="showContracts">
                <a>{{$t("contracts")}}</a>
              </router-link>
            </ul>

            <subMenu v-if="contractMenuShow"/>

          </div>
        </div>
      </div>
    </nav>

  </header>
</template>

<style>
.font-size-12px {
  font-size: 12px;
}
.menu-1 {
  list-style:none;
}
.menu-1 li {
  float: left;
  position: relative;
  padding-right: 10px;
}
div.top-header .b2 {
  font-size: 18px;
}
div.top-header .row {
  line-height: 38px;
}
.border-left-1px {
  border-left: 1px solid #C8C8C8;
}
.padding-17px-0{
  padding: 17px 0;
}
.padding-8px {
  padding: 8px;
}
.padding-left-10px {
  padding-left: 10px;
}
.padding-right-10px {
  padding-right: 10px
}
.font-size-25px {
  font-size: 25px;
}
.aux-text{
  display: inline-block !important;
}
.top-header{
  border-bottom: 1px solid #C8C8C8;
}
.border-sgs {
  border-bottom: 5px solid #FF6600;
  height: 100%;
}

/*Configurações Padrões*/
ul.menu {
  z-index: 1000;
  position: relative;
}
ul.menu, .menu li, .menu a { margin:0; padding:0; list-style:none; text-decoration:none; }
ul.menu > li > ul { padding-left: 0; }
ul.menu ul { position:absolute; display:none; }

/*ul.menu ul{ position:absolute; display:none;}*/

/* Configurações nivel 1*/
/*ul.menu{ float:left; font-family:Verdana, Geneva, sans-serif; font-size:15px; border-radius:5px; padding:0 5px;}*/
ul.menu {
  float: left;
  font-size: 14px;
}
.menu li {
  float: left;
  position: relative;
}
.menu li a {
  display: block;
  line-height: 40px;
  min-height: 40px;
  float: left;
  padding: 0 15px;
  transition: all 0.1s linear;
}
.menu.root > li > a {
  line-height: 74px;
  height: 73px;
  text-align: center;
}
.menu ul.submenu a {
  min-width: 200px;
}
.menu li:hover > ul.submenu-1 {
  display: block;
  top: 73px;
  padding: 0;
}
.menu li:hover > ul.submenu-2 {
  display: block;
  top:0;
  left: 200px;
  padding: 0px;
}
.menu li:hover > ul.submenu-3 {
  display: block;
  top:0;
  left: 200px;
  padding: 0px;
}
.menu li:hover > ul.submenu-1 li {
  width: 100%;
}
.menu li:hover > ul.submenu-2 li {
  width: 100%;
}
.menu li:hover > ul.submenu-3 li {
  width: 100%;
}
.menu li:hover > ul.submenu-1 li a {
  width: 100%;
}
.menu li:hover > ul.submenu-2 li a {
  width: 100%;
}
.menu li:hover > ul.submenu-3 li a {
  width: 100%;
}
.navbar {
  margin-bottom: 0;
}

/*Configurações de cores*/

.menu {
  background:#fff;
}
.menu a {
  color:#000;
}
.menu li:hover > a {
  background-color: #636363;
  color: #fff
}
.submenu {
  background: #fff;
  color: #000;
}
.submenu li:hover > a {
  background-color: #DA251C;
  color: #fff
}
ul.submenu {
  border-top: 1px solid #e91b23;
  border-bottom: 3px solid #e91b23;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0,0,0,.175);
  padding: 5px 0;
}
ul.menu .submenu li {
  border-bottom: 1px solid #e0eded;
}

</style>




// WEBPACK FOOTER //
// MenuNoResponsive.vue?e2911c56